import { Button } from "antd";
import React, { useState } from "react";
import ModalAddTrip from "../modal/ModalAddTrip";
import ModalAddSeat from "../modal/ModalAddSeat";
import { ISeatDetail } from "../../../../models/trip";
import { useModalLockScroll } from "../../../../hooks/useModalLockScroll";

interface ButtonAddSeatProps {
  tripId: string;
  busId: string;
  onSuccess: (value: ISeatDetail[]) => void;
  selectedSeats: ISeatDetail[];
}

const ButtonAddSeat: React.FC<ButtonAddSeatProps> = (
  props: ButtonAddSeatProps
) => {
  const { selectedSeats, onSuccess, busId, tripId } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);
    useModalLockScroll(isModalOpen);
  return (
    <div>
      <Button onClick={showModal} className="font-medium" type="primary" size="large">
        Thêm vé
      </Button>
      <ModalAddSeat
        onClose={handleCancel}
        selectedSeats={selectedSeats}
        visible={isModalOpen}
        onSuccess={onSuccess}
        busId={busId}
        tripId={tripId}
      />
    </div>
  );
};

export default ButtonAddSeat;
